import Project from "../model/Project";
import { FindManyOptions, promiseRequest } from "./ServiceApi";
import { ServiceApi } from "./ServiceApiWithLoading";

export interface ProjectContributor {
    user_id: number;
    user_name: string;
    user_photo: string;
    total_time: string;
    total_minutes: number;
}

export interface ProjectAggregatedTime {
    label: string;
    total_time: string;
    total_minutes: number;
}

export interface ProjectWithTime extends Project {
    short_name: string;
    status_name: string;
    total_time: string;
    current_month_time: string;
    previous_month_time: string;
    combined_recent_time: string;
    combined_recent_minutes: number;
    top_contributors: ProjectContributor[];
    others?: ProjectAggregatedTime;
}

/**
 * Interface para uma tarefa no dashboard de projetos
 */
export interface ITaskDashboard {
    task_id: number;
    task_name: string;
    ticket_code: string;
    priority: number;
    project_id: number | null;
    project_name: string | null;
    project_short_name: string | null;
    status_name: string;
    status_color: string;
    user_total_time: string; // formato HH:MM
    user_total_minutes: number;
}

/**
 * Interface para os dados de um usuário no dashboard de projetos
 */
export interface IUserTasksDashboard {
    user_id: number;
    user_name: string;
    department_name: string | null;
    user_photo: string | null;
    recent_tasks: ITaskDashboard[];       // máximo 3 tarefas
    in_progress_tasks: ITaskDashboard[];  // sem limite
    next_tasks: ITaskDashboard[];         // máximo 3 tarefas
    total_time: string;                   // formato HH:MM
    total_minutes: number;
    unique_tasks_count: number;
}

/**
 * Tipo para o retorno completo do endpoint getUserTasksProjectDashboard
 */
export type UserTasksProjectDashboardResponse = IUserTasksDashboard[];

export default class ProjectApi extends ServiceApi<Project>{

    constructor() {
        super('project');
    }

    async getTotalTaskTime(project_id: number, options: FindManyOptions<Project>): Promise<string> {
        var url = this.getBaseUrl() + `${project_id}/totalTaskTime`;
        url = this.getUrl(url, options);
        return await this.promiseWithLoading(promiseRequest(url, 'GET'));
    }

    async updateProjectTimeChange(task_id: string | number, old_project_id: string | number, new_project_id: string | number): Promise<string> {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `updateProjectTimeChange/`, 'PUT', {
            task_id, old_project_id, new_project_id
        }, true));
        return result;
    }

    async getTopProjectsByRegisteredTime(): Promise<ProjectWithTime[]> {
        var url = this.getBaseUrl() + `getTopProjectsByRegisteredTime`;
        return await this.promiseWithLoading(promiseRequest(url, 'GET'));
    }

    async getUserTasksProjectDashboard(): Promise<UserTasksProjectDashboardResponse> {
        var url = this.getBaseUrl() + `getUserTasksProjectDashboard`;
        return await this.promiseWithLoading(promiseRequest(url, 'GET'));
    }

}